export const SITE = {
  name: "Messenger of Shiva",
  shortName: "MoS",
  handle: "@messengerofshiva",
  instagram: "https://www.instagram.com/messengerofshiva",
  tagline: "Sacred Vedic Astrology · Kundli · Karmic Remedies",
};

export const STATS = {
  rating: "4.9/5",
  charts: "25,000+",
  countries: "80+",
  community: "1M+",
  years: "15",
  honors: "50",
};
